<template>
    <div class="sa-list-component">
        <div class="sa-list-component-header">
            <b-form @submit.prevent="onSubmit">
                <b-row>
                    <b-col cols="3">
                        <strong for="">Paziente</strong>
                        <b-form-input v-model="filtro.paziente"></b-form-input>
                    </b-col>
                    <b-col xs="12" sm="12" md="3" lg="3" xl="3">
                        <strong>Data Dal:</strong>
                        <date-picker format="DD-MM-YYYY" value-type="timestamp" v-model="filtro.dataDal" type="date"
                            placeholder="Data Dal"></date-picker>
                    </b-col>
                    <b-col xs="12" sm="12" md="3" lg="3" xl="3">
                        <strong>Data Al:</strong>
                        <date-picker format="DD-MM-YYYY" value-type="timestamp" v-model="filtro.dataAl" type="date"
                            placeholder="Data Al"></date-picker>
                    </b-col>
                    <b-col cols="3">
                        <strong for="">Operatore</strong>
                        <b-form-input v-model="filtro.operatore"></b-form-input>
                    </b-col>
                    <b-col cols="3">
                        <strong for="">Professione</strong>
                        <b-form-input v-model="filtro.professione"></b-form-input>
                    </b-col>
                </b-row>
                <b-row class="sa-form-btn-filter">
                    <b-col class="sa-padding-right text-right">
                        <b-button type="submit" variant="info">{{ this.$i18n.t("patients.lblFind") }}</b-button>
                        <b-button type="reset" v-on:click="onReset" variant="danger">{{
                            this.$i18n.t("patients.lblResetFilter") }}</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </div>
        <div class="sa-list-component-body">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right"
                        size="sm"></b-pagination>
                </b-col>
            </b-row>
            <div class="b-table-sticky-header">
                <label for="">Accessi Operatori</label>
                <b-table sticky-header ref="table" stacked="lg" striped hover :items="filteredItems" :fields="fields"
                    :current-page="currentPage" :per-page="perPage" sort-icon-left head-variant="light"
                    class="sa-b-table">

                </b-table>
            </div>
        </div>
        <div class="sa-list-component-footer">
            <b-modal ref="mdlAccessiAdd" size="xl" style="height: 100%">

            </b-modal>
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right"
                        size="sm"></b-pagination>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>

import UtilityMixin from "../../utility/UtilityMixin";
import DatePicker from "vue2-datepicker";
export default {
    mixins: [UtilityMixin],

    components: {
        DatePicker
    },
    mounted() { },
    computed: {
        rows: function () {
            return this.items.length;
        },
        filteredItems() {
            return this.items.filter(item => {


                if (this.filtro.paziente &&
                    !item.paziente.toLowerCase().includes(this.filtro.paziente.toLowerCase())) {
                    return false;
                }
                if (this.filtro.operatore &&
                    !item.operatore.toLowerCase().includes(this.filtro.operatore.toLowerCase())) {
                    return false;
                }
                if (this.filtro.professione &&
                    !item.professione.toLowerCase().includes(this.filtro.professione.toLowerCase())) {
                    return false;
                }
                if (this.filtro.dataDal) {
                    const dataAccesso = new Date(item.dataAccesso).getTime();
                    if (dataAccesso < this.filtro.dataDal) return false;
                }
                if (this.filtro.dataAl) {
                    const dataAccesso = new Date(item.dataAccesso).getTime();
                    if (dataAccesso > this.filtro.dataAl) return false;
                }
                return true;
            });
        }
    },
    data() {
        return {
            currentPage: 1,
            perPage: 20,

            items: [{
                "dataAccesso": "2025-12-10",
                "oraInizio": "08:30",
                "oraFine": "09:15",
                "durata": "45",
                "operatore": "Mario Rossi",
                "professione": "Infermiere",
                "paziente": "Giovanni Bianchi",
                "numeroPrestazioni": 2,
                "nota": "Accesso programmato"
            },
            {
                "dataAccesso": "2025-12-11",
                "oraInizio": "10:00",
                "oraFine": "10:30",
                "durata": "30",
                "operatore": "Laura Verdi",
                "professione": "Fisioterapista",
                "paziente": "Anna Neri",
                "numeroPrestazioni": 1,
                "nota": "Seduta di controllo"
            },
            {
                "dataAccesso": "2025-12-12",
                "oraInizio": "14:15",
                "oraFine": "15:00",
                "durata": "45",
                "operatore": "Paolo Conti",
                "professione": "Medico",
                "paziente": "Marco Gallo",
                "numeroPrestazioni": 3,
                "nota": "Visita specialistica"
            },
            {
                "dataAccesso": "2025-12-13",
                "oraInizio": "09:00",
                "oraFine": "09:20",
                "durata": "20",
                "operatore": "Sara Fontana",
                "professione": "Infermiere",
                "paziente": "Lucia Romano",
                "numeroPrestazioni": 1,
                "nota": "Medicazione"
            }],
            filtro: {
                paziente: "",
                operatore: "",
                professione: "",
                dataDal: null,
                dataAl: null
            },
            fields: [
                {
                    label: "Data Accesso",
                    key: "dataAccesso",
                    sortable: true,
                },
                {
                    label: "Ora Inizio",
                    key: "oraInizio",
                    sortable: true,
                },
                {
                    label: "Ora Fine",
                    key: "oraFine",
                    sortable: true,
                },
                {
                    label: "Durata",
                    key: "durata",
                    sortable: true,
                },
                {
                    label: "Operatore",
                    key: "operatore",
                    sortable: true,
                },
                {
                    label: "Professione",
                    key: "professione",
                    sortable: true,
                },
                {
                    label: "Paziente",
                    key: "paziente",
                    sortable: true,
                },
                {
                    label: "Numero Prestazioni",
                    key: "numeroPrestazioni",
                    sortable: true,
                },
                {
                    label: "Nota Accesso",
                    key: "nota",
                    sortable: true,
                },

            ]
        };
    },
    methods: {
        init(filtro) {
            if (filtro) {
                this.filtro = filtro;
            }
            this.loadStoricoGiacenzaArticolo();
        },
        onReset() { },
        onSubmit() {
            this.items.filter(e => e.paziente.includes(this.filtro.paziente))
        },
    },
};
</script>
